
export enum InvoiceCurrencyCd {
	CANADIAN_DOLLAR = 'CanadianDollar',
	US_DOLLAR = 'UsDollar'}

